export default {
  "path": "/demo/business-dynamic-component/index",
  "meta": {
    "name": "demo-动态表单组件",
    "title": "business/DynamicComponent 动态表单组件",
    "isComponentDoc": true,
    "category": "Form"
  }
};